import './historyLink.scss';
import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import CustomTooltip from './customTooltip';
import { isNullOrUndefined } from '../../store/storeFunctions';

class ColorBar extends React.Component {


    render() {       
        return  (<div className='colorBar'>
            {this.props.data.map((row, index) => {
                return <div
                key={index}
                data-tip
                data-for={`color-bar-tooltip-${index}`}
                className={this.getClassByType(row.type)}
                style={{
                display: 'inline-block',
                width: `${(row.value / this.props.sum) * 100}%`,
                }}>
                <CustomTooltip textAlign="right" placement='top' id={"colorBar" + index} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection' text={isNullOrUndefined(row.tooltipText) ? this.props.translate(this.props.emptyTooltipText) : row.tooltipText}>
                    <div style={{height:'100%', width:'100%'}}></div>
                </CustomTooltip>
            </div>
        })
           
        }
       </div>);
    }

    getClassByType = (type) => {
        switch(type) {
            case "Enabled" : return "enabled";
            case "Stopped": return "stopped";
            case "Terminated":  return "terminated";
        }
    }
}

export default withLocalize(ColorBar);